export const PROFILE_PAGE_TITLE = 'User profile';

export const LABELS = {
  PHONE: 'Phone Number',
  EMAIL: 'E-mail',
  USERNAME: 'Username',
  ROLE: 'Role',
  LOCATION: 'Location not provided',
} as const;

export const ROLES_HIDING_EDIT = ['merchant_staff', 'merchant_manager'] as const;

export const getRoleDisplayName = (role: string): string => {
  const map: Record<string, string> = {
    admin: 'Admin',
    merchant: 'Merchant',
    merchant_manager: 'Manager',
    merchant_staff: 'Staff',
  };
  return map[role] ?? role.charAt(0).toUpperCase() + role.slice(1).replace(/_/g, ' ');
};

export const AVATAR_BASE_URL = 'https://ui-avatars.com/api/';

export const getAvatarUrl = (name: string, username: string): string => {
  const displayName = encodeURIComponent(name || username || 'User');
  return `${AVATAR_BASE_URL}?name=${displayName}`;
};
